import React from 'react';

export const dadosGlobaisContext = React.createContext();

